import React, { useRef, useEffect } from 'react';
import '../../../vendor/pannellum/js/libpannellum.js';
import '../../../vendor/pannellum/js/pannellum.js';
import { PeekBox } from '@piiqtechnologies/ui-components';

const PannellumViewer = ({ viewerKey, config, onLoad, onSceneChange, onSceneChangeFadeDone, onError, onErrorCleared, onMousedown, onMouseup, onTouchstart, onTouchend, onAnimateFinished, }) => {
    const pannellumContainer = useRef(null);
    const enhancedOnAnimateFinished = (viewer) => (coordinates) => onAnimateFinished && onAnimateFinished(viewer.getConfig(), coordinates);
    useEffect(() => {
        const viewer = window.pannellum.viewer(pannellumContainer.current, config);
        const onAnimateDone = onAnimateFinished && enhancedOnAnimateFinished(viewer);
        onLoad(viewer);
        onSceneChange && viewer.on("scenechange", onSceneChange);
        onAnimateDone && viewer.on("animatefinished", onAnimateDone);
        onSceneChangeFadeDone && viewer.on("scenechangefadedone", onSceneChangeFadeDone);
        onError && viewer.on("error", onError);
        onErrorCleared && viewer.on("errorcleared", onErrorCleared);
        onMousedown && viewer.on("mousedown", onMousedown);
        onMouseup && viewer.on("mouseup", onMouseup);
        onTouchstart && viewer.on("touchstart", onTouchstart);
        onTouchend && viewer.on("touchend", onTouchend);
        return () => {
            onSceneChange && viewer.off("scenechange", onSceneChange);
            onAnimateDone && viewer.off("animatefinished", onAnimateDone);
            onSceneChangeFadeDone && viewer.off("scenechangefadedone", onSceneChangeFadeDone);
            onError && viewer.off("error", onError);
            onErrorCleared && viewer.off("errorcleared", onErrorCleared);
            onMousedown && viewer.off("mousedown", onMousedown);
            onMouseup && viewer.off("mouseup", onMouseup);
            onTouchstart && viewer.off("touchstart", onTouchstart);
            onTouchend && viewer.off("touchend", onTouchend);
        };
    }, [viewerKey]);
    return React.createElement(PeekBox, { key: viewerKey, ref: pannellumContainer });
};

export { PannellumViewer, PannellumViewer as default };
